import { useLingui } from '@lingui/react'
import { t } from '@lingui/core/macro'
import { useQueryClient } from '@tanstack/react-query'
import { locales, activateLocale, type Locale } from '@/i18n'
import { api } from '@/shared/lib/api'
import { AUTH } from '@/shared/lib/endpoints'

type Props = {
  persistToServer?: boolean
}

export function LocaleSwitcher({ persistToServer = false }: Props) {
  const { i18n } = useLingui()
  const queryClient = useQueryClient()

  const handleChange = async (locale: Locale) => {
    const tasks: Promise<unknown>[] = [activateLocale(locale)]
    if (persistToServer) {
      tasks.push(api.post(AUTH.profile, { json: { lang: locale } }))
    }
    await Promise.all(tasks)
    if (persistToServer)
      queryClient.invalidateQueries({ queryKey: ['session'] })
  }

  return (
    <select
      value={i18n.locale}
      onChange={(e) => handleChange(e.target.value as Locale)}
      aria-label={t`Language`}
      className="border-input bg-background focus:ring-ring/50 h-9 rounded-md border pr-7 pl-2 text-base outline-none focus:ring-2"
    >
      {Object.entries(locales).map(([code, label]) => (
        <option key={code} value={code}>
          {label}
        </option>
      ))}
    </select>
  )
}
